class ProductVariantSelector extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.buttonTrigger = this.buttonTrigger.bind(this)

    if (!this.els?.button?.exists) return

    this.els.button.elements.forEach(buttonEl => {
      this.listeners.add(buttonEl, `click`, this.buttonTrigger)
    })
  }

  buttonTrigger = event => {
    const variantTags = event.currentTarget.querySelector(
      `.${this.selectors.variantTags}` || null,
    )

    if (!variantTags && variantTags.innerHTML === '') {
      this.externalEls.override_tags_container.element.classList.remove(
        this.selectors.hasVariantTags,
      )
    } else {
      this.externalEls.override_tags_container.element.classList.add(
        this.selectors.hasVariantTags,
      )
    }

    this.externalEls.override_tags.element.innerHTML = variantTags.innerHTML

    const variant = event.currentTarget.value
    const changeEvent = new Event('change', {
      bubbles: true,
      cancelable: true,
    })

    this.externalEls.product_form_id.element.value =
      event.currentTarget.dataset.id
    this.select.value = variant
    this.select.dispatchEvent(changeEvent)

    this.els.button.elements.forEach(buttonEl => {
      buttonEl.classList.remove(this.selectors.variantButtonActive)
    })

    event.currentTarget.classList.add(this.selectors.variantButtonActive)

    window.BAO.dispatchEvent(window.BAO.EVENTS.CLOSE_ALL_DRAWERS)
  }

  get selectors () {
    return {
      variantTags: 'prd-VariantDrawer_ButtonText-tags',
      variantButtonActive: 'prd-VariantDrawer_Button-active',
      hasVariantTags: 'prd-Product_Tags-variantBadges',
    }
  }

  get select () {
    return document.querySelector('select[name="options[options]"]')
  }
}

if (!customElements.get('product-variant-selector')) {
  customElements.define('product-variant-selector', ProductVariantSelector)
}
